export const environment = {
  production: true,
  api_url: 'https://school-api.tvet.gov.kh',
  file_static_url: 'https://school-api.tvet.gov.kh/shared/file_data/download/',
  e_learning_file_url: "https://api.tvet-elearning.com/file_control/static/",
};
